import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78a77022"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "date_picker" }

import { computed, withDefaults } from 'vue'

type PropsType = {
  modelValue: Date
  disabledDate?: (date: Date) => boolean
  clearable?: boolean
  editable?: boolean
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
    modelValue: null,
    disabledDate: { type: Function, default: (date: Date) => date > new Date() },
    clearable: { type: Boolean, default: false },
    editable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: Date): void
  (e: 'change', value: Date): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: Date, disabledDate: (date: Date) => boolean, clearable: boolean, editable: boolean, disabled: boolean };





const selectedValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
    // TODO 親コンポーネントで'update:modelValue'を利用すればchangeは不要だが、利用しているコンポーネントの修正がなるべく発生しないように2重でchangeイベントを追加している。
    emit('change', value)
  },
})

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_date_picker, {
      modelValue: _unref(selectedValue),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedValue) ? (selectedValue).value = $event : null)),
      type: "date",
      placeholder: _ctx.$t('date_picker.select_date'),
      size: "small",
      "disabled-date": __props.disabledDate,
      clearable: __props.clearable,
      disabled: __props.disabled,
      editable: __props.editable,
      format: "YYYY/MM/DD"
    }, null, 8, ["modelValue", "placeholder", "disabled-date", "clearable", "disabled", "editable"])
  ]))
}
}

})